import { Component, Vue } from 'vue-property-decorator'
@Component({ name: 'PageTags' })
export default class PageTags extends Vue {
  private taglist = [
    { name: '首页', path: '/' },
    { name: '首页', path: '/' },
    { name: '首页', path: '/' },
    { name: '首页', path: '/' },
    { name: '首页', path: '/' },
    { name: '首页', path: '/' }
  ]

  created () {
    //
  }

  public onTagClick (item: any) {
    this.$router.push(item.path)
  }

  public onCloseClick (item: any) {
    //
  }
}
